import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import DataForm from 'forms/DataForm';
import uiSchema from './uiSchema';
import schema from './schema.js';
import DiaryGallery from './DiaryGallery';
import Camera from './Camera';

export default function DeliveryDiaryForm({ data = {}, onChange, enableCameraPhotoUpload = true, ...props }) {
  const [imageFiles, setImageFiles] = useState([]);
  const [updatedFormData, setUpdatedFormData] = useState(data);

  useEffect(() => {
    onChange && onChange({ ...updatedFormData, imageFiles });
  }, [updatedFormData, imageFiles]);

  const handleFormChange = (updatedFormData) => {
    setUpdatedFormData(updatedFormData);
  };

  const onUpdateImageFiles = (files) => {
    setImageFiles(files);
  };

  const handlePhotoTaken = (file) => {
    const newFiles = [...imageFiles, file];
    onUpdateImageFiles(newFiles);
  };

  return (
    <>
      <DataForm
        schema={schema}
        uiSchema={uiSchema}
        formData={updatedFormData}
        createFunc={() => {}}
        updateFunc={() => {}}
        dirty={true}
        onChange={handleFormChange}
        {...props}
        hideSubmitButton
      >
        {enableCameraPhotoUpload && (
          <>
            <Typography variant="h5" style={{ marginTop: 16 }}>
              照片上傳
            </Typography>
            <Divider />
            <Grid container spacing={2} style={{ paddingTop: 16 }}>
              <Camera onPhotoTaken={handlePhotoTaken} />
              <DiaryGallery
                onUpdateImageFiles={onUpdateImageFiles}
                files={imageFiles}
              />
            </Grid>
          </>
        )}
      </DataForm>
    </>
  );
}

DeliveryDiaryForm.propTypes = {
  data: PropTypes.object,
  onChange: PropTypes.func,
  enableCameraPhotoUpload: PropTypes.bool,
};
